/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const deviceType = async (): Promise<any> => {
  const deviceType = useJSONStore.getState().deviceType;
  const token = useUserStore.getState().userToken;
  const setDeviceType = useJSONStore.getState().setDeviceType;

  if (deviceType.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.deviceType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setDeviceType(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default deviceType;
